var authModule = {
    aFormBtnTexts: {
        havePwd: 'у меня есть пароль',
        forgotPwd: 'Получить пароль',
        notSentPwd: 'Не получили пароль?',
        submitSendPwd: 'Выслать пароль',
        submitStart: 'Продолжить',
        submitDoAuth: 'Войти',
        submitDoReg: 'Зарегистрироваться'
    },
    aPwdInputTpl: `
        <div class="custom-input-wrapper pwd-input-wrapper">
            <button class="show-hide-pwd-btn"></button>
            <input type="password" class="custom-input pwd-input auth-pwd-input" name="pwdcode" required placeholder="Ваш пароль">
        </div>
    `,
    init: function () {
        var $aForms = $('.multipurpose-auth-form');
        if ($aForms.length > 0) {
            if (typeof window.pryLoadRecaptcha === 'function') {
                window.pryLoadRecaptcha();
            }
            $aForms.each(function () {
                var $form = $(this);
                var formAuthShowFirstStep = $form.attr('aFormAuthShowFirstStep');

                authModule.morphFormPurpose($form, formAuthShowFirstStep);
                authModule.initPwdButtons($form);
                authModule.initAuthSubmit($form);
            });
            authModule.initAuthBackBtn();
        }

        $(document).on('click', '.doAuthFake', function (e) {
            e.preventDefault();
            $(this).closest('.custom-dropdown').find('.close-form').trigger('click');
        });

        $(document).on('click', '.retryAuth', function (e) {
            e.preventDefault();
            location.reload();
        })
    },
    renderResendPwdTimer: function (timeout) {
        return `<div class="resend-timeout-wrap">Запросить повторно <span class="resend-timeout__timer">00:${timeout}</span></div>`;
    },
    renderAgreementCheckbox: function (agreementUrl = false, policyUrl = false) {
        if (!agreementUrl) return '';

        return `
            <div class="user-account__privacy-policy">
                <label>
                    <input class="uk-checkbox" name="agree" value="1" required checked="checked" type="checkbox">
                    Я принимаю условия 
                    <a href="${agreementUrl}" target="_blank">пользовательского соглашения</a>
                    ${policyUrl ? ` и соглашаюсь с 
                        <a href="${policyUrl}" target="_blank">политикой о персональных данных</a>` : ''}
                </label>
            </div>
        `;
    },
    renderSuccessWindow: function ($form, message = '', warning = '') {
        return `
            <div class="event-info-aside__buy-ticket-successfully-content uk-text-center registration-positive">
                <img src="${app.options.assetsFolder}img/icons/positive.svg">
                ${message ? `<p>${message}</p>` : ''}
                ${warning ? `<span>${warning}</span>` : ''}
            </div>
        `;
    },
    renderFailWindow: function ($form, message = '', warning = '') {
        const tryAgainText = app.options.tryAgainText || 'Попробовать ещё';
        return `
            <div class="event-info-aside__buy-ticket-fail-content uk-text-center registration-negative">
                <img src="${app.options.assetsFolder}img/icons/negative.svg" alt="negative">
                <p>Что-то пошло не так</p>
                <a href="#" class="btn btn-outline-secondary retryAuth">${tryAgainText}</a>
            </div>
        `;
    },
    renderErrorMsg: function (message) {
        return `<span class="__font-weight-300 form-field-after-error error">${message}</span>`;
    },
    renderRegFields: function ($form) {
        return `
            <div class="reg-fields">
                <div class="custom-input-wrapper">
                    <input type="text" name="name" required class="custom-input" placeholder="Имя">
                </div>
                <div class="custom-input-wrapper">
                    <input type="text" name="lastname" required class="custom-input" placeholder="Фамилия">
                </div>
            </div>
        `;
    },
    errorResponseHandle: function ($form, response) {
        if (response.errors) {
            $.each(response.errors, function (fieldName, errors) {
                if (fieldName !== "reCaptcha") {
                    const $errorField = $(document).find('[name="' + fieldName + '"]');
                    $.each(errors, function (k, message) {
                        if ($errorField.next('.form-field-after-error').length > 0) {
                            $errorField
                                .next('.form-field-after-error')
                                .remove();
                        }
                        $errorField
                            .addClass('error')
                            .after($(authModule.renderErrorMsg(message)));
                    })
                } else {
                    const $field = $($form).find('.g-recaptcha');
                    $.each(errors, function (k, message) {
                        if ($field.next('.form-field-after-error').length > 0) {
                            $field
                                .next('.form-field-after-error')
                                .remove();
                        }
                        $field.after($(authModule.renderErrorMsg(message)));
                    })
                }
            });
        } else {
            $form.closest('.user-account-form').find('.auth-form-header').hide();
            const failWindow = $(authModule.renderFailWindow($form, response.message, response.warning));
            const $wrapper = $form.closest('.auth-form-wrapper');
            $wrapper
                .find('.auth-email-visual')
                .empty()
                .hide();
            $wrapper
                .hide()
                .after(failWindow);
        }

        app.setFormLoadingState($form, false);
    },
    initAuthBackBtn: function () {
        $(document).on('click', '.auth-form-back', function (e) {
            e.preventDefault();
            var $form = $(this).closest('.user-account-form').find('form');
            var morphData = $(this).data('morph');
            if (!morphData) {
                morphData = 'start';
            }
            $('.user-account-form').css('maxHeight', 'auto');
            $('.user-account-form').css('overflow-y', 'visible');
            $('.auth-email').val('');
            $('.auth-mobile').val('+7');
            authModule.morphFormPurpose($form, morphData);
        })
    },
    initAuthSubmit: function ($form) {
        $form.on('submit', function (e) {
            e.preventDefault();
            var $form = $(this);
            const gRecaptchaDiv = $form.find('.g-recaptcha');

            if ($form.hasClass('ajax-form-loading')) {
                return false;
            }

            if (typeof grecaptcha == 'undefined') {
                if (typeof window.pryLoadRecaptcha === 'function') {
                    window.pryLoadRecaptcha();
                }
                var grWaitAttempts = 0;
                var grWaitInterval = setInterval(function() {
                    if (typeof grecaptcha !== 'undefined') {
                        clearInterval(grWaitInterval);
                        $form.trigger('submit');
                    } else if (++grWaitAttempts >= 50) {
                        clearInterval(grWaitInterval);
                        gRecaptchaDiv.after($(authModule.renderErrorMsg('Ошибка. Попробуйте перезагрузить страницу')));
                    }
                }, 100);
                return false;
            }
            let reToken = '';

            try {
                grecaptcha.ready(function () {
                    grecaptcha.execute(window.jsConfig.frontSecret, {action: 'submit'}).then(function (token) {
                        reToken = token;

                        if (typeof window.jsConfig.authCfg == 'undefined' || !window.jsConfig.authCfg) {
                            window.jsConfig.authCfg = {};
                        }

                        var isInline = $form.attr('aFormInline');
                        var showAfterAuth = false;

                        if (isInline) {
                            showAfterAuth = $form.data('showafter');
                        }

                        var endpoint = $form.attr('action');
                        var formType = $form.attr('aFormType');
                        var $formHeader = $form.closest('.user-account-form').find('.auth-form-header');
                        var serializedForm = $form.serializeArray();
                        serializedForm.push({name: 'g-recaptcha-response', value: reToken});
                        app.setFormLoadingState($form, true);

                        $.ajax({
                            url: endpoint,
                            method: 'POST',
                            dataType: 'json',
                            data: $.param(serializedForm),
                            success: function (response) {
                                switch (formType) {
                                    case 'start':
                                        if (response.result || response.result === 'success') {
                                            const userExists = response.user && response.user.existing;
                                            if (userExists) {
                                                authModule.morphFormPurpose($form, 'doAuth');
                                            } else {
                                                authModule.morphFormPurpose($form, 'doReg');
                                            }
                                        } else {
                                            authModule.errorResponseHandle($form, response);
                                        }

                                        break;
                                    case 'doAuth':
                                        if (response.result || response.result === 'success') {
                                            var user = response.user;
                                            if (user.existing) {
                                                if (window.jsConfig.authCfg && window.jsConfig.authCfg.reload) {
                                                    location.reload();
                                                    return true;
                                                }

                                                $formHeader.text(user.data.fullName);
                                                var $authorizedDropdown = $(app.renderAuthorizedDropdown());
                                                if (!isInline) {
                                                    $form.replaceWith($authorizedDropdown);
                                                } else {
                                                    $form.closest('.inline-auth-holder').hide();
                                                    if (showAfterAuth) {
                                                        $(showAfterAuth).show();
                                                    }
                                                }

                                                app.setUserState(user);
                                                app.initPersonalMenus();

                                                if ($('.inline-auth-holder').is(':visible')) {
                                                    $('.inline-auth-holder').hide();
                                                    $('.event-info-aside__card').show();
                                                }
                                            } else {
                                                authModule.morphFormPurpose($form, 'doReg');
                                            }
                                        } else {
                                            authModule.errorResponseHandle($form, response);
                                        }

                                        break;
                                    case 'doReg':
                                        if (response.result || response.result === 'success') {
                                            authModule.morphFormPurpose($form, 'doConfirm');
                                            $('.notsent-pwd-badge, .forgot-pwd-badge')
                                                .after(authModule.renderWarning(response.message));
                                        } else {
                                            authModule.errorResponseHandle($form, response);
                                        }

                                        break;
                                    case 'doConfirm':
                                        if (response.result || response.result === 'success') {
                                            $formHeader.hide();
                                            var $successWindow = $(authModule.renderSuccessWindow($form, response.message, response.warning));
                                            $form.replaceWith($successWindow);
                                            var formAuthShowFirstStep = $form.attr('aRedirectAfterDoConfirm');

                                            if ($('.inline-auth-holder').is(':visible')) {
                                                $('.inline-auth-holder').hide();
                                                $('.event-info-aside__card').show();
                                            }

                                            if (formAuthShowFirstStep) {
                                                window.location.href = formAuthShowFirstStep
                                                return false;
                                            } else {
                                                setTimeout(() => location.reload(), 2000);
                                            }
                                        } else {
                                            authModule.errorResponseHandle($form, response);
                                        }
                                        break;
                                }

                                app.setFormLoadingState($form, false);
                            },
                            error: function (response) {
                                if (response.errors) {
                                    $.each(errorData.errors, function (fieldName, errors) {
                                        $.each(errors, function (k, message) {
                                            var $errorField = $form.find('[name="' + fieldName + '"]');
                                            if ($errorField.next('.form-field-after-error').length > 0) {
                                                $errorField.next('.form-field-after-error').remove();
                                            }
                                            $errorField
                                                .addClass('error')
                                                .after($(authModule.renderErrorMsg(message)));
                                        })
                                    });
                                } else {
                                    $formHeader.hide();
                                    var failWindow = $(authModule.renderFailWindow($form, response.message, response.warning));
                                    $form.hide().after(failWindow);
                                }

                                app.setFormLoadingState($form, false);
                            }
                        });
                    }).catch(function () {
                        gRecaptchaDiv
                            .after($(authModule.renderErrorMsg(
                                'Ошибка. Попробуйте перезагрузить страницу'
                            )));
                    });
                });
            } catch (e) {
                gRecaptchaDiv
                    .after($(authModule.renderErrorMsg(
                        'Ошибка. Попробуйте перезагрузить страницу'
                    )));
            }
        });
    },
    initPwdButtons: function ($form) {
        $form.on('click', '.have-pwd-badge', function (e) {
            e.preventDefault();
            var $btn = $(this);
            authModule.showPwdInput($form, $btn);
        });

        $form.on('click', '.notsent-pwd-badge, .forgot-pwd-badge', function (e) {
            e.preventDefault();
            var $btn = $(this);
            var endpoint = $form.attr('aFormPwdResendEndpoint');
            const forgotPwdBadge = $('.forgot-pwd-badge');
            if (typeof grecaptcha == 'undefined') {
                if (typeof window.pryLoadRecaptcha === 'function') {
                    window.pryLoadRecaptcha();
                }
                var grWaitAttempts = 0;
                var grWaitInterval = setInterval(function() {
                    if (typeof grecaptcha !== 'undefined') {
                        clearInterval(grWaitInterval);
                        $btn.trigger('click');
                    } else if (++grWaitAttempts >= 50) {
                        clearInterval(grWaitInterval);
                        forgotPwdBadge.after($(authModule.renderErrorMsg('Ошибка. Попробуйте перезагрузить страницу')));
                    }
                }, 100);
                return false;
            }

            try {
                grecaptcha.ready(function () {
                    grecaptcha.execute(window.jsConfig.frontSecret, {action: 'submit'}).then(function (token) {
                        $form.closest('.user-account-form').find('.auth-form-header').text('Подтверждение');
                        let ajaxData = $form.find('.auth-mobile, .auth-email').serializeArray();
                        ajaxData.push({name: 'g-recaptcha-response', value: token});
                        app.preventSpamClicks($btn, false);
                        authModule.resetFormErrors($form);

                        $.ajax({
                            url: endpoint,
                            method: 'POST',
                            dataType: 'json',
                            data: ajaxData,
                            success: function (response) {
                                const $fieldsContainer = $form.find('.form-fields-wrap');
                                const $formContainer = $form.closest('.user-account-form');

                                let resendTimer;
                                if (response.resendTimeout) {
                                    let resentTimeoutSeconds = response.resendTimeout;
                                    const $resendTimeoutWrap = $(authModule.renderResendPwdTimer(resentTimeoutSeconds));
                                    $btn.before($resendTimeoutWrap);
                                    $btn.hide();
                                    resendTimer = setInterval(function () {
                                        const timeoutStr = resentTimeoutSeconds > 9 ? resentTimeoutSeconds : '0' + resentTimeoutSeconds;
                                        $resendTimeoutWrap.find('> span').text('00:' + timeoutStr);
                                        resentTimeoutSeconds--;
                                        if (resentTimeoutSeconds < 0) {
                                            if ($form.attr('aformtype') !== 'doReg') {
                                                $form.find('.notsent-pwd-badge, .forgot-pwd-badge').show();
                                            }
                                            $form.find('.resend-timeout-wrap').remove();
                                            clearInterval(resendTimer);
                                        }
                                    }, 1000);
                                }

                                if (response.result === false) {
                                    let errorText = 'Ошибка. Попробуйте перезагрузить страницу'

                                    authModule.resetFormErrors($formContainer);

                                    if (response.errors.length > 0) {
                                        errorText = response.errors;
                                    }

                                    forgotPwdBadge
                                        .after($(authModule.renderErrorMsg(
                                            errorText
                                        )));
                                } else {
                                    $btn.after(authModule.renderWarning('Ссылка для смены пароля отправлена на почту <span>' + response.sentTo + '</span> проверьте папки входящие и спам.'));
                                }
                                app.preventSpamClicks($btn, true);
                            },
                            error: function (response) {
                                app.preventSpamClicks($btn, true);
                                forgotPwdBadge
                                    .after($(authModule.renderErrorMsg(
                                        'Error. Попробуйте перезагрузить страницу'
                                    )));
                            }
                        });

                        if ($form.find('.enter-troubles').length === 0) {
                            $btn
                                .next('span')
                                .after('<div class="user-account__privacy-policy enter-troubles">' +
                                    '<label>' +
                                    'Проблемы со входом? <a href="mailto:info@pryamaya.ru" target="_blank">Техническая поддержка</a>' +
                                    '</label>' +
                                    '</div>');
                        }
                    }).catch(function () {
                        forgotPwdBadge
                            .after($(authModule.renderErrorMsg(
                                'Ошибка. Попробуйте перезагрузить страницу'
                            )));
                    });
                });
            } catch (e) {
                forgotPwdBadge
                    .after($(authModule.renderErrorMsg(
                        'Ошибка. Попробуйте перезагрузить страницу'
                    )));
            }
        });
    },
    resetFormErrors: function ($form) {
        $form.find('input').removeClass('error');
        $form.find('span.error').remove();
    },
    morphFormPurpose: function ($form, purpose) {
        var $fieldsContainer = $form.find('.form-fields-wrap');
        var $formParent = $form.closest('.user-account-form');
        var $formBackBtn = $formParent.find('.auth-form-back');
        var $formHeader = $formParent.find('.auth-form-header');
        var $additionalHeader = $formParent.find('.auth-form-additional-header');

        authModule.resetFormErrors($form);
        var $btn = $form.find('.pwd-buttons-badge');

        if (purpose === 'start') {
            $additionalHeader.show();
        } else {
            $additionalHeader.hide();
        }

        switch (purpose) {
            case 'sendPwd':
                $form.find('.auth-pwd-input').remove();
                $btn.show().removeClass('forgot-pwd-badge negative')
                    .addClass('have-pwd-badge positive')
                    .find('a').text(authModule.aFormBtnTexts.havePwd);

                $form.attr('aFormType', 'sendPwd')
                    .find('.aFormSubmitBtn .button-text')
                    .text(authModule.aFormBtnTexts.submitSendPwd);

                $form.attr('action', $form.attr('aFormPwdSendEndpoint'));
                break;

            case 'start':
                $form.find('.pwd-input-wrapper').remove();
                $btn.hide();

                $form.attr('aFormType', 'start')
                    .find('.aFormSubmitBtn .button-text')
                    .text(authModule.aFormBtnTexts.submitStart);
                $formHeader.text('Войти или зарегистрироваться');
                $formBackBtn.hide();

                $form.attr('action', $form.attr('aFormStartEndpoint'));

                $form.find('.auth-email').attr('type', 'email');
                $form.closest('.auth-form-wrapper').find('.auth-email-visual').empty().hide();

                $('.auth-email, .auth-mobile, .iti__flag-container').removeAttr('readonly').removeClass('readonly-modif');
                $('.iti__flag-container').removeAttr('readonly').removeClass('readonly-modif');
                $form.find('.auth-mobile').closest('.custom-input-wrapper').hide();
                $form.find('.auth-email').closest('.custom-input-wrapper').show();
                $form.find('p.uk-text-center').show();
                $form.find('#g-recaptcha-response').removeAttr('required');
                $form.find('.phone-code-input__wrap').hide();
                $form.find('.reg-fields').remove();
                $form.find('.user-account__privacy-policy').remove();
                $form.find('.captcha-container').remove();

                $form.find('.auth-email').keyup(function () {
                    if ($(this).val() !== '') {
                        $('.auth-mobile').attr('readonly', 'readonly').addClass('readonly-modif');
                        $('.iti__flag-container').attr('readonly', 'readonly').addClass('readonly-modif');
                    } else {
                        $('.auth-mobile').removeAttr('readonly').removeClass('readonly-modif');
                        $('.iti__flag-container').removeAttr('readonly').removeClass('readonly-modif');
                    }
                });

                $form.find('.auth-mobile').keyup(function () {
                    if ($(this).val().length > 2) {
                        $('.auth-email').attr('readonly', 'readonly').addClass('readonly-modif');
                    } else {
                        $('.auth-email').removeAttr('readonly').removeClass('readonly-modif');
                    }
                });

                break;

            case 'doAuth':
                $('.auth-email, .auth-mobile').off();
                $fieldsContainer.append($(authModule.aPwdInputTpl));

                if ($form.find('.resend-timeout-wrap').length === 0) {
                    $btn.show()
                        .removeClass('have-pwd-badge positive')
                        .addClass('forgot-pwd-badge negative')
                        .find('a')
                        .html(authModule.aFormBtnTexts.forgotPwd);
                }

                $form.attr('aFormType', purpose)
                    .find('.aFormSubmitBtn .button-text')
                    .text(authModule.aFormBtnTexts.submitDoAuth);

                if ($form.find('.auth-email').val() !== '') {
                    $form.find('.auth-mobile').closest('.custom-input-wrapper').hide();
                    const $authEmail = $form.find('.auth-email');
                    const emailVal = $authEmail.val();

                    $authEmail.attr('type', 'hidden')
                        .removeAttr('readonly')
                        .removeClass('readonly-modif')
                        .closest('.custom-input-wrapper').hide();

                    const $visual = $form.closest('.auth-form-wrapper').find('.auth-email-visual');
                    if ($visual.length) {
                        $visual.html('<div class="custom-input-wrapper"><input type="text" class="custom-input mb-16" value="' + emailVal.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;') + '" readonly disabled></div>');
                        $visual.show();
                    }
                } else if ($form.find('.auth-mobile').val() !== '') {
                    $form.find('.auth-email').closest('.custom-input-wrapper').hide();
                    $form.find('.auth-mobile').attr('readonly', 'readonly').addClass('readonly-modif');
                    $form.find('.iti__flag-container').attr('readonly', 'readonly').addClass('readonly-modif');
                }

                $form.find('p.uk-text-center').hide();
                $form.find('.phone-code-input__wrap').show();
                $formBackBtn.show().data('morph', 'start');
                $formHeader.text('Вход');

                $form.attr('action', $form.attr('aFormAuthEndpoint'));
                break;

            case 'doReg':
                $fieldsContainer.find('.auth-mobile').parent().after(authModule.renderRegFields($form))
                $form.find('p.uk-text-center').hide();
                $form.attr('aFormType', purpose)
                    .find('.aFormSubmitBtn .button-text')
                    .text(authModule.aFormBtnTexts.submitDoReg);
                $form.find('.auth-mobile').closest('.custom-input-wrapper').show();

                $form.find('.auth-email')
                    .attr('type', 'email')
                    .closest('.custom-input-wrapper').show();
                $form.find('.phone-code-input__wrap').show();
                $('.auth-email, .auth-mobile').removeAttr('readonly').removeClass('readonly-modif');

                $('.iti__flag-container').removeAttr('readonly').removeClass('readonly-modif');
                if ($form.attr('aFormAuthShowFirstStep') !== 'doReg') {
                    if ($form.find('.auth-email').val().length !== 0) {
                        $form.find('.auth-email').attr('readonly', 'readonly').addClass('readonly-modif');
                    } else if ($form.find('.auth-mobile').val().length > 5) {
                        $form.find('.auth-mobile').attr('readonly', 'readonly').addClass('readonly-modif');
                        $form.find('.iti__flag-container').attr('readonly', 'readonly').addClass('readonly-modif');
                    }
                }

                if (typeof window.jsConfig.agreement !== 'undefined' && window.jsConfig.agreement.showInReg) {
                    $form.find('.aFormSubmitBtn').after(
                        authModule.renderAgreementCheckbox(
                            window.jsConfig.agreement.agreementUrl,
                            window.jsConfig.agreement.policyUrl
                        )
                    );
                }

                $form.find('.phone-code-input__wrap').hide();
                $formBackBtn.show().data('morph', 'start');
                $formHeader.text('Регистрация');

                $form.attr('action', $form.attr('aFormRegEndpoint'));

                break;
            case 'doConfirm':
                $formBackBtn.hide();
                $formHeader.text('Подтверждение');
                $('.auth-email, .auth-mobile').off();
                $form.find('.reg-fields').remove();
                $form.find('.user-account__privacy-policy').remove();
                $form.find('.captcha-container').remove();

                $form.attr('action', $form.attr('aFormAuthEndpoint'));

                $form.find('.auth-email').attr('type', 'email').show();
                $form.find('.auth-mobile').closest('.custom-input-wrapper').hide();
                $fieldsContainer.append($(authModule.aPwdInputTpl));
                $btn.show().removeClass('have-pwd-badge positive')
                    .addClass('forgot-pwd-badge negative')
                    .find('a').text(authModule.aFormBtnTexts.notSentPwd);

                $form.attr('aFormType', purpose)
                    .find('.aFormSubmitBtn .button-text')
                    .text(authModule.aFormBtnTexts.submitDoAuth);

                break;
        }
    },
    showPwdInput: function ($form, $btn = false) {
        var $fieldsContainer = $form.find('.form-fields-wrap');
        if (!$btn) {
            $btn = $form.find('.pwd-buttons-badge');
        }

        authModule.resetFormErrors($form);
        $fieldsContainer.append($(authModule.aPwdInputTpl));
        $btn.removeClass('have-pwd-badge positive')
            .addClass('forgot-pwd-badge negative')
            .find('a').html(authModule.aFormBtnTexts.forgotPwd);

        $form.attr('aFormType', 'doAuth')
            .find('.aFormSubmitBtn .button-text')
            .text(authModule.aFormBtnTexts.submitDoAuth);

        $form.attr('action', $form.attr('aFormAuthEndpoint'));

        if ($form.find('.auth-email').val() !== '') {
            $form.find('.auth-mobile').closest('.custom-input-wrapper').hide();
            $form.find('.auth-email')
                .attr('type', 'hidden')
                .removeAttr('readonly')
                .removeClass('readonly-modif')
                .closest('.custom-input-wrapper').hide();
        }
    },
    renderWarning: function (message) {
        return '<span class="error warning">' + message + '</span>'
    }
}

$("document").ready(function () {
    authModule.init();
});
